import { isFeatureEnabled, getVariant } from '../featureToggles.module'

const _getters = {
  canUseSkipSlide: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'AHA-39045-skip-slide')
  },
  isSkipSlidePaidFeature: (_, __, ___, rootGetters) => {
    const variant = getVariant(rootGetters, 'AHA-39045-skip-slide')
    return variant?.name?.toLowerCase()?.includes('ispaid')
  },
  skipSlides: (state) => {
    return state.skipSlides
  },

  visibleSlides: (_, getters, rootState) => {
    const { presentation } = rootState
    if (!presentation?.slides) return []
    if (!getters.canUseSkipSlide) {
      return presentation.slides
    }
    return presentation.slides.filter((slide) => !getters.skipSlides?.[slide.id])
  },

  visibleQuizSlides: (_, getters, __, rootGetters) => {
    return (getters.visibleSlides || []).filter((item) => rootGetters['slideModule/isQuizSlide'](item))
  },

  isLeaderboardAfterAllQuizs: (_, getters, rootState) => {
    const slidesQuiz = getters.visibleQuizSlides
    const slides = getters.visibleSlides
    const index = slides.findIndex((item) => item.id === rootState.slideActive.id)
    let indexQuiz = 0
    if (slidesQuiz.length) {
      indexQuiz = slides.findIndex(
        (item) => item.id === slidesQuiz[slidesQuiz.length - 1].id,
      )
    }
    if (index > indexQuiz) {
      return true
    }
    return false
  },
}

export default _getters
